/**
 * "Shadow AI" nav icon — the AI Shadow Audit (conversations) entry.
 *
 * Inlined from `public/assets/common/sidebar-shadow-icon.svg`, which drew itself in a baked
 * #5F656F as an <img>, so it neither took the row's active/hover colour nor the dark palette.
 * Same two adjustments as `ai-operations-icon.tsx`: `currentColor`, and strokeWidth 1.5 so
 * the two rings weigh the same as the lucide icons around them.
 */
export function ShadowAiIcon({ className }: { className?: string }) {
	return (
		<svg viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' className={className} aria-hidden='true'>
			<path
				d='M11.05 12.4909C14.1102 12.4909 16.5909 10.0101 16.5909 6.94995C16.5909 3.88977 14.1102 1.409 11.05 1.409C7.9898 1.409 5.50903 3.88977 5.50903 6.94995C5.50903 10.0101 7.9898 12.4909 11.05 12.4909Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.13196 16.409C10.1922 16.409 12.6729 13.9282 12.6729 10.868C12.6729 7.80785 10.1922 5.32708 7.13196 5.32708C4.07178 5.32708 1.59101 7.80785 1.59101 10.868C1.59101 13.9282 4.07178 16.409 7.13196 16.409Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}
